<template>
  <v-container class="bg-background ma-0 pa-4">
    <v-row v-if="selectedItemIndex == -1" class="ma-0 pa-0 spacing" align="center">
      <v-col class="ma-0 pa-0">
        <v-icon icon="mdi-bell-outline" color="primary" class="mr-2"></v-icon>
        <span>My Notifications</span>
      </v-col>
    </v-row>

    <v-divider v-if="selectedItemIndex == -1"></v-divider>
    <v-container v-if="userMessages.length > 0 && selectedItemIndex == -1" class="mt-4 ma-0 pa-0">
      <template v-for="(item, i) in userMessages" :key="i">
        <v-hover v-slot="{ isHovering, props }">
          <v-card @click="itemClicked(i)" elevation="0" :class="{ 'on-hover': isHovering }" class="my-2 pa-0"
            v-bind="props">
            <v-container class="ma-0 px-4 py-2">
              <v-row class="ma-0 pa-0" justify="center">
                <v-col cols="12">
                  <v-row dense align="center">
                    <v-col cols="11">
                      <v-row dense>
                        <v-col cols="12">
                          <v-row>
                            <v-icon v-if="item.userStarred" color="yellow" class="pt-4">mdi-star</v-icon>
                            <v-col cols="11">
                              <span :class="item.status == 'unread' ? 'heading-block' : ''">
                                {{ item.title }}
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="description-block">
                          <HtmlRender class="htmlClass" :html-string="item.description"></HtmlRender>
                        </v-col>
                        <v-col cols="12">
                          <span class="date-block">
                            {{ item.messageDateTime }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col class="align-end">
                      <v-col v-if="item.importance == 'importance'" class="align-end">
                        <v-icon class="pl-3" color="orange" size="10">mdi-checkbox-blank-circle</v-icon>
                      </v-col>
                      <v-menu bottom left>
                        <template v-slot:activator="{ props }">
                          <v-btn class="pa-0" flat icon="mdi-dots-vertical" v-bind="props"></v-btn>
                        </template>

                        <v-list>
                          <v-list-item v-if="item.status === 'read'" @click="onMenuClick('unread', item)">
                            <v-list-item-title>Mark Unread</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="item.status === 'unread'" @click="onMenuClick('read', item)">
                            <v-list-item-title>Mark read</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="item.userStarred" @click="onMenuClick('unstar', item)">
                            <v-list-item-title>Remove star</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!item.userStarred" @click="onMenuClick('star', item)">
                            <v-list-item-title>Mark star</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-hover>
      </template>
    </v-container>
    <v-container class="bg-background ma-0 pa-4" v-else-if="selectedItemIndex > -1">
      <v-row class="ma-0 pa-0" align="center">
        <v-btn v-if="selectedItemIndex > -1" class="ma-0 mr-2" color="secondary" size="x-small" @click="back()"
          icon="mdi-chevron-left">
        </v-btn>
        <v-col class="ma-0 pa-0">
          <v-icon icon="mdi-bell-outline" color="primary" class="mr-2"></v-icon>
          <span>My Notifications</span>
        </v-col>
      </v-row>
      <v-container class="mt-4 ma-0 pa-0">
        <v-divider></v-divider>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col cols="12">
            <v-row dense align="start" justify="end">
              <v-col cols="11">
                <v-row dense>
                  <v-col cols="12">
                    <v-row>
                      <v-icon v-if="userMessages[selectedItemIndex].userStarred" color="yellow"
                        class="pt-4">mdi-star</v-icon>
                      <v-col cols="11">
                        <span :class="userMessages[selectedItemIndex].status == 'unread' ? 'heading-block' : ''">
                          {{ userMessages[selectedItemIndex].title }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="overflow-auto px-4">
                  <HtmlRender class="htmlClass" :html-string="selectedItemDescription"></HtmlRender>
                </v-row>
              </v-col>
              <v-col class="align-end">
                <v-menu bottom left>
                  <template v-slot:activator="{ props }">
                    <v-btn flat icon="mdi-dots-vertical" color="background" v-bind="props"></v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="userMessages[selectedItemIndex].status === 'read'"
                      @click="onMenuClick('unread', userMessages[selectedItemIndex])">
                      <v-list-item-title>Mark Unread</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="userMessages[selectedItemIndex].status === 'unread'"
                      @click="onMenuClick('read', userMessages[selectedItemIndex])">
                      <v-list-item-title>Mark read</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="userMessages[selectedItemIndex].userStarred"
                      @click="onMenuClick('unstar', userMessages[selectedItemIndex])">
                      <v-list-item-title>Remove star</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!userMessages[selectedItemIndex].userStarred"
                      @click="onMenuClick('star', userMessages[selectedItemIndex])">
                      <v-list-item-title>Mark star</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container v-else>
      <div class="d-flex justify-center align-center h-screen">
        No messages
      </div>
    </v-container>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment-timezone";
import HtmlRender from "@/components/Test/HtmlRender";
import { AnalyticsEvents, recordAnalyticsEvent } from "@/services/awsPinpointAnalyticsService";
//import _ from "lodash";

export default {
  name: "MyNotificationsPage",

  data: () => ({
    selectedItemIndex: -1,
    selectedItemDescription: "",
  }),
  components: {
    HtmlRender
  },
  async created() {
    this.$store.commit("userMessagesLoadedFromServer", false);
    this.$store.dispatch("loadUserMessages", {}).then(() => {
      setTimeout(() => {
        window.MathJax.typesetPromise();
      }, 10);
    });
    recordAnalyticsEvent(AnalyticsEvents.v2MyNotifPageOpen);
  },
  computed: {
    ...mapState(["userMessageUpdated"]),
    userMessages: {
      get() {
        let userMessages = this.$store.state.userMessages;
        userMessages = userMessages.map(item => {
          item.messageDateTime = moment(new Date(item.messageDateTime)).format('Do MMM YYYY');
          return item;
        });

        return userMessages;
      },
    },
  },
  mounted() { },
  watch: {
    userCurrentDomain() { },
  },
  methods: {
    onMenuClick(event, item) {
      let reqData = {
        userMessageId: item.userMessageId,
        status: item.status,
        userStarred: item.userStarred
      };

      if (event == 'read') {
        reqData.status = "read";
        recordAnalyticsEvent(AnalyticsEvents.v2MyNotifMarkAsRead, { notificationId: item.userMessageId });
      } else if (event == 'unread') {
        reqData.status = "unread";
        recordAnalyticsEvent(AnalyticsEvents.v2MyNotifMarkAsUnRead, { notificationId: item.userMessageId });
      } else if (event == 'star') {
        reqData.userStarred = true;
        recordAnalyticsEvent(AnalyticsEvents.v2MyNotifMarkAsStarred, { notificationId: item.userMessageId });
      } else if (event == 'unstar') {
        reqData.userStarred = false;
        recordAnalyticsEvent(AnalyticsEvents.v2MyNotifUnMarkAsStarred, { notificationId: item.userMessageId });
      }
      this.$store.commit("userMessageUpdated", false);
      this.$store.dispatch("updateUserMessageStatus", reqData);
      this.userMessages = this.userMessages.map(m => {
        if (m.userMessageId == item.userMessageId) {
          m.status = reqData.status;
          m.userStarred = reqData.userStarred;
        }
        return m;
      });

      const unreadCount = this.userMessages.filter(m => m.status === "unread").length;
      this.$store.commit("setUnreadNotificationsCount", unreadCount);
    },
    itemClicked(index) {
      this.selectedItemIndex = index;
      this.selectedItemDescription = this.userMessages[index].description;
      setTimeout(() => {
        window.MathJax.typesetPromise();
      }, 10);
      if (this.userMessages[index].status == 'unread') {
        this.onMenuClick('read', this.userMessages[index]);
      }
      recordAnalyticsEvent(AnalyticsEvents.v2MyNotifViewDetails, { notificationId: this.userMessages[index].userMessageId });
    },
    back() {
      this.selectedItemDescription = "";
      this.selectedItemIndex = -1;
    }
  },
};
</script>

<style scoped>
.v-card {
  border: 1px solid rgb(var(--v-theme-secondary));
}

.v-card.on-hover {
  cursor: pointer;
  border: 1px solid rgb(var(--v-theme-primary));
  background-color: #fff;
}

.heading-block {
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #282828;
}

.date-block {
  font-weight: 500;
  font-size: 12.8px;
  line-height: 10px;
  color: #888888;
}

.selected-item-description {
  font-weight: 400;
  font-size: 12.8px;
  line-height: 15px;
  color: #515151;
}

.description-block {
  font-weight: 400;
  font-size: 12.8px;
  line-height: 15px;
  color: #515151;
  height: 45px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
<style>
.spacing {
  padding: 15px 5px !important;
}

.no-new-line>a.v-breadcrumbs-item {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: none;
}

.no-new-line>li.v-breadcrumbs-item {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: none;
}
</style>